import auth from './auth'
import registrations from './registrations'
import resources from './resources'
import utilities from './utilities'
import notifications from './notifications'
import utils from './utils'

const backendLib = {
  ...auth,
  ...notifications,
  ...registrations,
  ...resources,
  ...utilities,

  // util functions that call multiple endpoints
  ...utils
}

export default backendLib
